import { Interfaces as IAddressLookup } from '@service-victoria/component-library/components/AddressLookup/props';
import { OptionType } from '@service-victoria/component-library/components/AutoComplete/props';
import { isEmpty } from 'lodash-es';
import * as Yup from 'yup';

import * as constants from 'utils/constants';
import { isPostOfficeBox, doesNotContainEmoji, Regex } from 'utils/validations';

export const getFields = (prefix: string) => [
  `${prefix}.summaryData.label`,
  `${prefix}.summaryData.value`,
  `${prefix}.fullDetails.id`,
  `${prefix}.fullDetails.fullAddress`,
  `${prefix}.fullDetails.postCode`,
  `${prefix}.fullDetails.state`,
  `${prefix}.fullDetails.suburb`
];

export const emptyAddress = {
  summaryData: {
    label: '',
    value: ''
  },
  fullDetails: { id: '', fullAddress: '', postCode: '', state: '', suburb: '', lga: '' }
};

export const addressSchema = Yup.object().shape<IAddressLookup.AddressData>({
  fullDetails: Yup.object().shape<IAddressLookup.AddressData['fullDetails']>({
    id: Yup.string().notRequired(),
    fullAddress: Yup.string()
      .required(constants.AddressValidationErrors.place)
      .test(
        'isPostOfficeBox',
        constants.AddressValidationErrors.noPostBox,
        function validate(address) {
          if (address) {
            return !isPostOfficeBox(address);
          } else {
            return true;
          }
        }
      )
      .test('isFullAddressValid', constants.AddressValidationErrors.place, doesNotContainEmoji),
    postCode: Yup.string()
      .required(constants.AddressValidationErrors.place)
      .matches(Regex.POSTCODE, constants.AddressValidationErrors.postcode)
      .max(4, constants.AddressValidationErrors.place),
    state: Yup.string().required(constants.AddressValidationErrors.place),
    lga: Yup.string(),
    suburb: Yup.string()
      .required(constants.AddressValidationErrors.place)
      .matches(Regex.SUBURB, constants.AddressValidationErrors.suburb)
  }),
  summaryData: Yup.mixed().when('fullDetails', {
    is: fullDetails => {
      const isManualAddress =
        isEmpty(fullDetails.id) &&
        !isEmpty(fullDetails.fullAddress) &&
        !isEmpty(fullDetails.postCode) &&
        !isEmpty(fullDetails.state) &&
        !isEmpty(fullDetails.suburb);
      return isManualAddress;
    },
    then: Yup.object().notRequired(),
    otherwise: Yup.mixed()
      .test(
        'emptyValue',
        constants.AddressValidationErrors.place,
        function validate(address?: OptionType) {
          return address ? !isEmpty(address?.label) : false;
        }
      )
      .test(
        'no value selected from drop down',
        constants.AddressValidationErrors.pickAddress,
        function validate(address: OptionType) {
          return !isEmpty(address?.label) && !isEmpty(address?.value);
        }
      )
      .test(
        'isPostOfficeBox',
        constants.AddressValidationErrors.noPostBox,
        function validate(address: OptionType) {
          if (address?.label) {
            return !isPostOfficeBox(address?.label);
          } else {
            return true;
          }
        }
      )
  })
});
